<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

      <p v-if="views.length == 0" class="pt-3 text-center">No views</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table mt-3">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Product</th>
                  <th class="pl-3">Views</th>
                  <th class="first-right px-3">Country</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(view, index) in views" :key="index.id">
              
              <td class="pl-3">
                <a v-if="view.product" :href="`/product/${view.product.id}/view`" target="_blank">{{view.product.name}}</a>
                <div v-else>Product not found</div>
              </td>
              <td class="pl-3">{{view.views}}</td>
              <td class="px-3"><img :src="'/images/flags/svg/'+view.country_flag" class="country_flag" :title="view.country"></td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Product • Views • Country</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(view, index) in views" :key="index">
  
        <td class="pl-2">
            <div>
              <a v-if="view.product" :href="`/product/${view.product.id}/view`" target="_blank">{{view.product.name}}</a>
              <div v-else>Product not found</div>
              </div>
            <div>{{ view.views }}</div>
            <div>{{ view.country }}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>

export default {
  data() {
    return {
      views: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getViews();
  },

  methods: {
    getViews() {
      
      this.loading = true;

      axios.post('/analytics/get', {type: 'group'}).
      then((response) => {
        this.views = response.data;
        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
td.agent { text-align: left; width:70px; }
</style>